/** Marketing / short-link hosts that only serve RoofHub (/) and apply-by-id (/:id). */
export function isRoofHubDomain() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h.includes("goodleap.plus");
}
